import React, { useState } from "react";
import { useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { FiMenu } from "react-icons/fi";
import {
  FaUsers,
  FaCalendarDay,
  FaChartLine,
  FaFileInvoiceDollar,
  FaKey,
  FaArrowRightFromBracket,
} from "react-icons/fa6";
import { auth } from "../../firebaseConfig";
import Drawer from "./Drawer";

const NAV = [
  { to: "/suppliers", label: "Προμηθευτές", icon: FaUsers },
  { to: "/daily-reports", label: "Απολογισμός Ημέρας", icon: FaCalendarDay },
  { to: "/period-report", label: "Απολογισμός Περιόδου", icon: FaChartLine },
  { to: "/ekkathariseis", label: "Εκκαθαρίσεις", icon: FaFileInvoiceDollar },
  { to: "/change-pin", label: "Αλλαγή PIN", icon: FaKey },
];

const Sidebar = () => {
  const [open, setOpen] = useState(false);
  const login = useSelector((state) => state.ui.login);
  const navigate = useNavigate();

  const close = () => setOpen(false);

  const handleLogout = async () => {
    close();
    await signOut(auth);
    navigate("/login");
  };

  if (!login) return null;

  return (
    <>
      <header className="sticky top-0 z-30 border-b border-brand-600/10 bg-white/90 backdrop-blur">
        <div className="flex items-center justify-between px-4 py-3">
          <NavLink to="/" className="flex items-center gap-2">
            <img src="/fish.svg" alt="" className="h-7 w-7" />
            <span className="text-xl font-extrabold tracking-widest text-brand-700">ΛΙΝΟΣ</span>
          </NavLink>
          <button
            onClick={() => setOpen(true)}
            aria-label="Μενού"
            className="rounded-xl p-2 text-brand-700 transition hover:bg-brand-50 active:scale-95"
          >
            <FiMenu size={24} />
          </button>
        </div>
      </header>

      <Drawer open={open} onClose={close}>
        <div className="flex items-center gap-2 border-b border-slate-100 px-5 py-4">
          <img src="/fish.svg" alt="" className="h-8 w-8" />
          <span className="text-lg font-extrabold tracking-widest text-brand-700">ΨΑΡΟΥΛΗΣ</span>
        </div>

        <nav className="flex-1 overflow-y-auto px-3 py-3">
          {NAV.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              onClick={close}
              className={({ isActive }) =>
                `mb-1 flex items-center gap-3 rounded-xl px-3 py-3 text-[15px] font-medium transition ${
                  isActive ? "bg-brand-50 text-brand-700" : "text-slate-600 hover:bg-slate-50"
                }`
              }
            >
              <Icon size={18} className="shrink-0" />
              {label}
            </NavLink>
          ))}

          <button
            onClick={handleLogout}
            className="mt-1 flex w-full items-center gap-3 rounded-xl px-3 py-3 text-[15px] font-medium text-rose-600 transition hover:bg-rose-50"
          >
            <FaArrowRightFromBracket size={18} className="shrink-0" />
            Αποσύνδεση
          </button>
        </nav>

        <div className="border-t border-slate-100 px-5 py-3 text-xs text-slate-400">
          v.{process.env.REACT_APP_VERSION}
        </div>
      </Drawer>
    </>
  );
};

export default Sidebar;
